(function () {
  'use strict';

  var GEN_OPTIONS = {
    pro_11: ['1st Gen (2018)', '2nd Gen (2020)', '3rd Gen (2021)', '4th Gen (2022)', 'M4 (2024)', 'M5 (2025)'],
    pro_13: ['3rd Gen (2018)', '4th Gen (2020)', '5th Gen (2021)', '6th Gen (2022)', 'M4 (2024)', 'M5 (2025)'],
    air_11: ['4th Gen (2020)', '5th Gen (2022)', 'M2 (2024)', 'M3 (2025)', 'M4 (2026)'],
    air_13: ['M3 (2025)', 'M4 (2026)'],
    ipad_109: ['10th Gen (2022)', '11th Gen / A16 (2025)'],
  };

  function isM4M5(gen) {
    return String(gen || '').indexOf('M4') === 0 || String(gen || '').indexOf('M5') === 0;
  }

  function tierNeededFor(line, size, gen) {
    if (line === 'ipad') return true;
    if (line === 'air' && size === '11') return true;
    if (line === 'pro' && size === '11' && !isM4M5(gen)) return true;
    return false;
  }

  function resolveProductKey(state) {
    var line = state.line;
    var size = state.size;
    var gen = state.gen;
    var tier = state.tier;

    if (line === 'ipad') return tier === 'premium' ? 'BRYDGE_11' : 'MAX_109';
    if (line === 'pro' && size === '11') {
      return isM4M5(gen) ? 'MAX11_M4M5' : tier === 'budget' ? 'AIR_MAX_PLUS' : 'MAX11_BASE';
    }
    if (line === 'pro' && size === '13') {
      return isM4M5(gen) ? 'MAX13_M4M5' : 'MAX13_BASE';
    }
    if (line === 'air' && size === '11') {
      return tier === 'budget' ? 'AIR_MAX_PLUS' : 'MAX11_BASE';
    }
    if (line === 'air' && size === '13') return 'MAX13_BASE';
    return null;
  }

  function deviceLabel(state) {
    var lineLabel = state.line === 'pro' ? 'iPad Pro' : state.line === 'air' ? 'iPad Air' : state.line === 'ipad' ? 'iPad' : '';
    var sizeLabel =
      state.line === 'ipad'
        ? '10.9″'
        : state.size === '11'
          ? '11″'
          : state.size === '13'
            ? state.line === 'pro'
              ? '12.9″/13″'
              : '13″'
            : '';
    return (lineLabel + ' ' + sizeLabel + ' (' + state.gen + ')').replace(/\s+/g, ' ').trim();
  }

  function parseConfig(root) {
    var script = root.querySelector('[data-kbd-config]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.error('Keyboard Decision Engine: invalid config JSON', error);
      return null;
    }
  }

  function hasCartableVariant(live) {
    if (!live) return false;
    var id = Number(live.variantId != null ? live.variantId : live.id);
    return Number.isFinite(id) && id > 0;
  }

  function createEl(tag, className, attrs) {
    var el = document.createElement(tag);
    if (className) el.className = className;
    if (attrs) {
      Object.keys(attrs).forEach(function (key) {
        if (key === 'text') el.textContent = attrs[key];
        else el.setAttribute(key, attrs[key]);
      });
    }
    return el;
  }

  function KeyboardDecisionEngine(root) {
    this.root = root;
    this.config = parseConfig(root) || {};
    this.state = { step: 'line', line: null, size: null, gen: null, tier: null };
    this.currentLiveProduct = null;
    this.cacheDom();
    this.bindEvents();
    this.updateUi();
  }

  KeyboardDecisionEngine.prototype.cacheDom = function () {
    this.progress = this.root.querySelector('[data-kbd-progress]');
    this.steps = this.root.querySelectorAll('[data-kbd-step]');
    this.sizeContainer = this.root.querySelector('[data-kbd-size-options]');
    this.genContainer = this.root.querySelector('[data-kbd-gen-options]');
    this.matchBadge = this.root.querySelector('[data-kbd-match-badge]');
    this.resultCard = this.root.querySelector('[data-kbd-result-card]');
    this.resultImg = this.root.querySelector('[data-kbd-result-img]');
    this.resultDevice = this.root.querySelector('[data-kbd-result-device]');
    this.resultName = this.root.querySelector('[data-kbd-result-name]');
    this.resultMeta = this.root.querySelector('[data-kbd-result-meta]');
    this.resultReason = this.root.querySelector('[data-kbd-result-reason]');
    this.resultBullets = this.root.querySelector('[data-kbd-result-bullets]');
    this.resultAvailability = this.root.querySelector('[data-kbd-result-availability]');
    this.addToCartButton = this.root.querySelector('[data-kbd-add-to-cart]');
  };

  KeyboardDecisionEngine.prototype.bindEvents = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var target = e.target.closest('[data-kbd-action]');
      if (target && self.root.contains(target)) {
        e.preventDefault();
        var action = target.getAttribute('data-kbd-action');
        var value = target.getAttribute('data-kbd-value');
        if (action === 'line') self.setLine(value, target);
        else if (action === 'size') self.setSize(value, target);
        else if (action === 'gen') self.setGen(value, target);
        else if (action === 'tier') self.setTier(value, target);
        else if (action === 'back') self.goBack();
        else if (action === 'restart') self.restart();
        return;
      }

      if (e.target.closest('[data-kbd-add-to-cart]') && self.addToCartButton && self.root.contains(self.addToCartButton)) {
        e.preventDefault();
        self.addToCart();
      }
    });
  };

  KeyboardDecisionEngine.prototype.clearSelected = function (selector) {
    var nodes = this.root.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.remove('is-selected');
  };

  KeyboardDecisionEngine.prototype.setLine = function (line, button) {
    this.clearSelected('[data-kbd-action="line"]');
    if (button) button.classList.add('is-selected');

    if (line === 'ipad') {
      this.state = { step: 'gen', line: line, size: '109', gen: null, tier: null };
    } else {
      this.state = { step: 'size', line: line, size: null, gen: null, tier: null };
    }
    this.updateUi();
  };

  KeyboardDecisionEngine.prototype.setSize = function (size, button) {
    this.clearSelected('[data-kbd-action="size"]');
    if (button) button.classList.add('is-selected');
    this.state.size = size;
    this.state.gen = null;
    this.state.tier = null;
    this.state.step = 'gen';
    this.updateUi();
  };

  KeyboardDecisionEngine.prototype.setGen = function (gen, button) {
    this.clearSelected('[data-kbd-action="gen"]');
    if (button) button.classList.add('is-selected');
    this.state.gen = gen;
    this.state.tier = null;
    this.state.step = tierNeededFor(this.state.line, this.state.size, gen) ? 'tier' : 'result';
    this.updateUi();
  };

  KeyboardDecisionEngine.prototype.setTier = function (tier, button) {
    this.clearSelected('[data-kbd-action="tier"]');
    if (button) button.classList.add('is-selected');
    this.state.tier = tier;
    this.state.step = 'result';
    this.updateUi();
  };

  KeyboardDecisionEngine.prototype.goBack = function () {
    var s = this.state;
    if (s.step === 'result' && tierNeededFor(s.line, s.size, s.gen)) {
      this.state.step = 'tier';
      this.state.tier = null;
      this.clearSelected('[data-kbd-action="tier"]');
    } else if (s.step === 'result' || s.step === 'tier') {
      this.state.step = 'gen';
      this.state.tier = null;
      this.clearSelected('[data-kbd-action="tier"]');
      this.clearSelected('[data-kbd-action="gen"]');
    } else if (s.step === 'gen') {
      if (s.line === 'ipad') {
        this.state = { step: 'line', line: null, size: null, gen: null, tier: null };
        this.clearSelected('[data-kbd-action="line"]');
      } else {
        this.state.step = 'size';
        this.state.gen = null;
        this.clearSelected('[data-kbd-action="gen"]');
        this.clearSelected('[data-kbd-action="size"]');
      }
    } else if (s.step === 'size') {
      this.state = { step: 'line', line: null, size: null, gen: null, tier: null };
      this.clearSelected('[data-kbd-action="line"]');
      this.clearSelected('[data-kbd-action="size"]');
    }
    this.updateUi();
  };

  KeyboardDecisionEngine.prototype.restart = function () {
    this.state = { step: 'line', line: null, size: null, gen: null, tier: null };
    this.currentLiveProduct = null;
    this.clearSelected('.is-selected');
    this.updateUi();
  };

  KeyboardDecisionEngine.prototype.progressMeta = function () {
    var step = this.state.step;
    var line = this.state.line;
    var size = this.state.size;
    var gen = this.state.gen;
    var isIpad = line === 'ipad';
    var needsTier = isIpad || (line && size && gen && tierNeededFor(line, size, gen)) || step === 'tier';
    var total = isIpad ? 3 : needsTier ? 4 : 3;
    var progressMap = isIpad
      ? { line: 0, gen: 1, tier: 2, result: total, nomatch: total }
      : { line: 0, size: 1, gen: 2, tier: 3, result: total, nomatch: total };
    return { total: total, progressN: progressMap[step] || 0 };
  };

  KeyboardDecisionEngine.prototype.updateStepLabels = function () {
    var meta = this.progressMeta();
    var total = meta.total;
    var copy = this.config.copy || {};
    var prefix = copy.stepLabelPrefix || 'Step';
    var joiner = copy.stepLabelOf || 'of';
    var isIpad = this.state.line === 'ipad';
    var stepNums = isIpad
      ? { line: 1, gen: 2, tier: 3 }
      : { line: 1, size: 2, gen: 3, tier: 4 };

    this.steps.forEach(function (stepEl) {
      var name = stepEl.getAttribute('data-kbd-step');
      var label = stepEl.querySelector('[data-kbd-step-of]');
      if (!label || !stepNums[name]) return;
      label.textContent = prefix + ' ' + stepNums[name] + ' ' + joiner + ' ' + total;
    });
  };

  KeyboardDecisionEngine.prototype.renderProgress = function () {
    if (!this.progress) return;
    var meta = this.progressMeta();
    var total = meta.total;
    var progressN = meta.progressN;

    this.progress.innerHTML = '';

    for (var i = 1; i <= total; i++) {
      var segment = createEl('span', 'kbd-engine__progress-segment');
      segment.setAttribute('data-kbd-progress-bar', String(i));
      if (progressN >= i) segment.classList.add('is-active');
      this.progress.appendChild(segment);
    }

    this.updateStepLabels();
  };

  KeyboardDecisionEngine.prototype.renderSizeOptions = function () {
    if (!this.sizeContainer) return;
    this.sizeContainer.innerHTML = '';
    var line = this.state.line;
    var sizes = (this.config.copy && this.config.copy.sizes) || {};
    var options =
      line === 'pro'
        ? sizes.pro || [
            { value: '11', label: '11-inch', sub: 'iPad Pro 11″' },
            { value: '13', label: '12.9″ / 13-inch', sub: 'iPad Pro 12.9″ or 13″' },
          ]
        : sizes.air || [
            { value: '11', label: '11-inch', sub: 'iPad Air 11″ (or 10.9″)' },
            { value: '13', label: '13-inch', sub: 'iPad Air 13″' },
          ];

    var self = this;
    options.forEach(function (opt) {
      var btn = createEl('button', 'kbd-engine__choice', {
        type: 'button',
        'data-kbd-action': 'size',
        'data-kbd-value': opt.value,
      });
      if (self.state.size === opt.value) btn.classList.add('is-selected');
      btn.appendChild(createEl('span', 'kbd-engine__choice-title', { text: opt.label }));
      btn.appendChild(createEl('span', 'kbd-engine__choice-sub', { text: opt.sub }));
      self.sizeContainer.appendChild(btn);
    });
  };

  KeyboardDecisionEngine.prototype.renderGenOptions = function () {
    if (!this.genContainer) return;
    this.genContainer.innerHTML = '';
    var line = this.state.line;
    var size = this.state.size;
    var genKey = line === 'ipad' ? 'ipad_109' : line && size ? line + '_' + size : null;
    var gens = genKey ? GEN_OPTIONS[genKey] || [] : [];
    var self = this;

    gens.forEach(function (g) {
      var btn = createEl('button', 'kbd-engine__choice kbd-engine__choice--gen', {
        type: 'button',
        'data-kbd-action': 'gen',
        'data-kbd-value': g,
        text: g,
      });
      if (self.state.gen === g) btn.classList.add('is-selected');
      self.genContainer.appendChild(btn);
    });
  };

  KeyboardDecisionEngine.prototype.renderTierCopy = function () {
    var tier = (this.config.copy && this.config.copy.tier) || {};
    var isIpad = this.state.line === 'ipad';
    var premium = isIpad
      ? tier.ipadPremium || {
          label: 'Premium — Brydge 11.0',
          sub: 'Colour-matched aluminum build, adjustable tilt, backlit keys.',
        }
      : tier.premium || {};
    var budget = isIpad
      ? tier.ipadBudget || {
          label: 'Rugged — 10.9 MAX+',
          sub: '4-ft drop protection, multi-touch trackpad.',
        }
      : tier.budget || {};
    var buttons = this.root.querySelectorAll('[data-kbd-action="tier"]');
    var self = this;

    buttons.forEach(function (button) {
      var value = button.getAttribute('data-kbd-value');
      var copy = value === 'budget' ? budget : premium;
      var title = button.querySelector('.kbd-engine__choice-title');
      var sub = button.querySelector('.kbd-engine__choice-sub');
      if (title && copy.label) title.textContent = copy.label;
      if (sub && copy.sub) sub.textContent = copy.sub;
      button.classList.toggle('is-selected', value === self.state.tier);
    });
  };

  KeyboardDecisionEngine.prototype.getLiveProduct = function (key) {
    var live = (this.config.liveProducts || {})[key];
    if (live && hasCartableVariant(live)) return live;
    return live || null;
  };

  KeyboardDecisionEngine.prototype.showRecommendation = function () {
    var key = resolveProductKey(this.state);
    var catalog = ((this.config.catalog || {})[key]) || null;
    var live = this.getLiveProduct(key);
    this.currentLiveProduct = live;

    if (!catalog) return false;

    if (this.matchBadge) this.matchBadge.hidden = false;
    if (this.resultCard) this.resultCard.hidden = false;

    var title = (live && live.title) || catalog.name;
    var priceFormatted = (live && live.priceFormatted) || (catalog.fallbackPrice ? '$' + catalog.fallbackPrice : '');
    var image = (live && live.image) || catalog.fallbackImg || '';
    var url = (live && live.url) || '/products/' + catalog.fallbackHandle;

    if (this.resultImg) {
      if (image) {
        this.resultImg.src = image;
        this.resultImg.alt = (live && live.imageAlt) || title;
        this.resultImg.hidden = false;
      } else {
        this.resultImg.hidden = true;
      }
    }
    if (this.resultDevice) this.resultDevice.textContent = deviceLabel(this.state);
    if (this.resultName) this.resultName.textContent = title;
    if (this.resultMeta) {
      var metaParts = [catalog.tagline, priceFormatted].filter(Boolean);
      this.resultMeta.textContent = metaParts.join(' · ');
    }
    if (this.resultReason) this.resultReason.textContent = catalog.why;
    if (this.resultBullets) {
      this.resultBullets.innerHTML = '';
      (catalog.bullets || []).forEach(function (bullet) {
        var li = document.createElement('li');
        li.textContent = bullet;
        this.resultBullets.appendChild(li);
      }, this);
      this.resultBullets.hidden = !(catalog.bullets && catalog.bullets.length);
    }

    this.updateAddToCartButton(live, priceFormatted, url);
    return true;
  };

  KeyboardDecisionEngine.prototype.updateAddToCartButton = function (live, priceFormatted, url) {
    if (!this.addToCartButton) return;
    var messages = this.config.messages || {};
    var labelPrefix = messages.addToCart || 'Add to cart';
    var canAdd = hasCartableVariant(live) && live.variantAvailable !== false && live.available !== false;
    var isSoldOut = hasCartableVariant(live) && (live.variantAvailable === false || live.available === false);

    delete this.addToCartButton.dataset.variantId;
    delete this.addToCartButton.dataset.productUrl;

    if (canAdd) {
      this.addToCartButton.disabled = false;
      this.addToCartButton.removeAttribute('disabled');
      this.addToCartButton.textContent = priceFormatted ? labelPrefix + ' — ' + priceFormatted : labelPrefix;
      this.addToCartButton.dataset.variantId = String(live.variantId);
    } else if (isSoldOut) {
      this.addToCartButton.disabled = true;
      this.addToCartButton.setAttribute('disabled', 'disabled');
      this.addToCartButton.textContent = messages.soldOut || 'Sold out';
    } else if (url) {
      this.addToCartButton.disabled = false;
      this.addToCartButton.removeAttribute('disabled');
      this.addToCartButton.textContent = messages.viewProduct || 'View product';
      this.addToCartButton.dataset.productUrl = url;
    } else {
      this.addToCartButton.disabled = true;
      this.addToCartButton.setAttribute('disabled', 'disabled');
      this.addToCartButton.textContent = messages.soldOut || 'Sold out';
    }

    if (this.resultAvailability) {
      this.resultAvailability.hidden = !isSoldOut;
      this.resultAvailability.textContent = isSoldOut ? messages.soldOut || 'Sold out' : '';
    }
  };

  KeyboardDecisionEngine.prototype.updateUi = function () {
    var step = this.state.step;

    if (step === 'size') this.renderSizeOptions();
    if (step === 'gen') this.renderGenOptions();
    if (step === 'result' && !this.showRecommendation()) {
      this.state.step = 'nomatch';
      step = 'nomatch';
    }

    this.steps.forEach(function (node) {
      var name = node.getAttribute('data-kbd-step');
      var isActive = name === step;
      node.hidden = !isActive;
      node.classList.toggle('is-active', isActive);
    });

    this.renderProgress();

    if (step === 'tier') this.renderTierCopy();
  };

  KeyboardDecisionEngine.prototype.getCartElement = function () {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  };

  KeyboardDecisionEngine.prototype.getCartSectionIds = function () {
    var cart = this.getCartElement();
    if (cart && typeof cart.getSectionsToRender === 'function') {
      return cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }
    return ['cart-drawer', 'cart-icon-bubble'];
  };

  KeyboardDecisionEngine.prototype.hasUsableCartSections = function (data) {
    if (!data || !data.sections) return false;
    var ids = this.getCartSectionIds();
    return ids.every(function (id) {
      return typeof data.sections[id] === 'string' && data.sections[id].length > 0;
    });
  };

  KeyboardDecisionEngine.prototype.addToCart = async function () {
    if (!this.addToCartButton) return;

    if (this.addToCartButton.dataset.productUrl) {
      window.location.href = this.addToCartButton.dataset.productUrl;
      return;
    }

    var rawId = this.addToCartButton.dataset.variantId || (this.currentLiveProduct && this.currentLiveProduct.variantId);
    var variantId = Number(rawId);
    if (!Number.isFinite(variantId) || variantId <= 0) {
      console.error('Keyboard Decision Engine: missing variant id');
      return;
    }

    var messages = this.config.messages || {};
    var labelPrefix = messages.addToCart || 'Add to cart';
    var priceFormatted = (this.currentLiveProduct && this.currentLiveProduct.priceFormatted) || '';
    var defaultLabel = priceFormatted ? labelPrefix + ' — ' + priceFormatted : labelPrefix;

    this.addToCartButton.disabled = true;
    this.addToCartButton.setAttribute('disabled', 'disabled');
    this.addToCartButton.textContent = messages.adding || 'Adding…';

    try {
      var data = await this.addVariantToCart(variantId);
      if (!data || data.status) throw new Error((data && (data.description || data.message)) || 'Add to cart failed');

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        try {
          await publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'keyboard-decision-engine',
            productVariantId: String(variantId),
            cartData: data,
          });
        } catch (publishError) {
          console.warn('Keyboard Decision Engine: cart publish failed', publishError);
        }
      }

      await this.openCartDrawer(data);
      this.addToCartButton.disabled = false;
      this.addToCartButton.removeAttribute('disabled');
      this.addToCartButton.textContent = defaultLabel;
    } catch (error) {
      console.error('Keyboard Decision Engine: add to cart failed', error);
      this.addToCartButton.disabled = false;
      this.addToCartButton.removeAttribute('disabled');
      this.addToCartButton.textContent = defaultLabel;
    }
  };

  KeyboardDecisionEngine.prototype.addVariantToCart = async function (variantId) {
    var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var cart = this.getCartElement();

    try {
      var formData = new FormData();
      formData.append('id', String(variantId));
      formData.append('quantity', '1');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', this.getCartSectionIds().join(','));
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }

      var config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/javascript' } };
      config.method = 'POST';
      config.headers = Object.assign({}, config.headers || {}, { 'X-Requested-With': 'XMLHttpRequest' });
      delete config.headers['Content-Type'];
      config.body = formData;

      var response2 = await fetch(cartAddUrl, config);
      var data2 = await response2.json();
      if (response2.ok && data2 && !data2.status) {
        return this.hasUsableCartSections(data2) ? data2 : this.attachCartSections(data2);
      }
    } catch (error) {
      console.warn('Keyboard Decision Engine: sectioned cart add failed', error);
    }

    var response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId) || variantId, quantity: 1 }] }),
    });
    var data = await response.json();
    return !response.ok || data.status ? data : this.attachCartSections(data);
  };

  KeyboardDecisionEngine.prototype.attachCartSections = async function (data) {
    var sectionIds = this.getCartSectionIds();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var urls = [
      root + '?sections=' + encodeURIComponent(sectionIds.join(',')),
      root + '?sections=' + encodeURIComponent(sectionIds.join(',')) + '&sections_url=' + encodeURIComponent(window.location.pathname),
      ((window.routes && window.routes.cart_url) || '/cart') + '?sections=' + encodeURIComponent(sectionIds.join(',')),
    ];

    for (var i = 0; i < urls.length; i += 1) {
      try {
        var response = await fetch(urls[i], { headers: { Accept: 'application/json' } });
        if (!response.ok) continue;
        var sections = await response.json();
        if (sections && typeof sections === 'object') {
          var merged = Object.assign({}, data || {}, { sections: sections });
          if (this.hasUsableCartSections(merged)) return merged;
          if (!data || !data.sections) data = merged;
        }
      } catch (error) {
        console.warn('Keyboard Decision Engine: could not load cart sections', error);
      }
    }
    return data || {};
  };

  KeyboardDecisionEngine.prototype.prepareCartDrawerForContents = function (cart) {
    if (!cart) return;
    cart.classList.remove('is-empty');
    var drawerInner = cart.querySelector('.drawer__inner');
    if (drawerInner) drawerInner.classList.remove('is-empty');
    var items = cart.querySelector('cart-drawer-items');
    if (items) items.classList.remove('is-empty');
  };

  KeyboardDecisionEngine.prototype.applyCartSectionsManually = function (parsedState) {
    var cart = this.getCartElement();
    if (!cart || !parsedState || !parsedState.sections) return false;
    var sectionsToRender =
      typeof cart.getSectionsToRender === 'function'
        ? cart.getSectionsToRender()
        : [
            { id: 'cart-drawer', selector: '#CartDrawer' },
            { id: 'cart-icon-bubble' },
          ];
    var updated = false;
    sectionsToRender.forEach(function (section) {
      var html = parsedState.sections[section.id];
      if (!html) return;
      var sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!sectionElement) return;
      try {
        var source = new DOMParser().parseFromString(html, 'text/html').querySelector(section.selector || '.shopify-section');
        if (!source) return;
        sectionElement.innerHTML = source.innerHTML;
        updated = true;
      } catch (error) {
        console.warn('Keyboard Decision Engine: manual section update failed', section.id, error);
      }
    });
    return updated;
  };

  KeyboardDecisionEngine.prototype.openCartDrawer = async function (data) {
    var cart = this.getCartElement();
    var payload = data || {};
    if (!this.hasUsableCartSections(payload)) payload = await this.attachCartSections(payload);
    this.prepareCartDrawerForContents(cart);

    if (cart && typeof cart.renderContents === 'function' && this.hasUsableCartSections(payload)) {
      try {
        cart.renderContents(payload);
        this.prepareCartDrawerForContents(cart);
        return;
      } catch (error) {
        console.warn('Keyboard Decision Engine: renderContents failed', error);
      }
    }

    if (this.applyCartSectionsManually(payload)) {
      this.prepareCartDrawerForContents(cart);
      if (cart && typeof cart.open === 'function') {
        cart.open();
        return;
      }
    }

    if (cart && typeof cart.open === 'function') {
      cart.open();
      return;
    }

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble) bubble.click();
  };

  function initAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('[data-keyboard-decision-engine]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].dataset.kbdReady === 'true') continue;
      nodes[i].dataset.kbdReady = 'true';
      new KeyboardDecisionEngine(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('[data-keyboard-decision-engine]')
      : null;
    if (section) section.dataset.kbdReady = 'false';
    initAll(event.target || document);
  });
})();
